export default "/images/c9cb3b514ec2c02f83c5137024520c4e.avif";